module.exports = __webpack_public_path__ + "static/media/NexaLight.e48a1597.woff";